/* API */
export const API_VERSION = 'v1';
const { REACT_APP_API_URL } = process.env;

//export const API_URL = REACT_APP_API_URL;
export const API_URL = 'https://prod.api.aws.goodip.io';
//export const API_URL = 'http://localhost:8080/';

export const API_ROUTE_PROJECTS = '/projects';
export const API_ROUTE_REPORT = '/report';